// W-0821 — Modal de confirmação pré-lançamento.
// Mostra total de boletos a transferir + lista de cobradores afetados.

import React from 'react';
import { Modal, Button, Table, Alert } from 'react-bootstrap';
import { formatarBRL } from '../helpers';
import { LIMITE_LOTE_BOLETOS } from '~/constant';

const ModalConfirmacaoLancamento = ({
  show,
  resumoAtribuicoes,
  totalBoletos,
  totalValor,
  cobradoresMap,
  onConfirmar,
  onCancelar,
  emAndamento,
}) => {
  const totalChunks = Math.max(1, Math.ceil(totalBoletos / LIMITE_LOTE_BOLETOS));
  return (
    <Modal show={show} onHide={onCancelar} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirmar lançamento</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Você está prestes a transferir <strong>{totalBoletos}</strong>{' '}
          boleto(s) totalizando <strong>{formatarBRL(totalValor)}</strong> em
          cobrança.
        </p>
        {totalChunks > 1 && (
          <Alert variant="info" className="py-2 mb-2">
            O envio será dividido em <strong>{totalChunks}</strong> lotes de até{' '}
            {LIMITE_LOTE_BOLETOS} boletos cada.
          </Alert>
        )}
        <Table size="sm" striped bordered>
          <thead>
            <tr>
              <th>Cobrador</th>
              <th className="text-right">Qtd</th>
              <th className="text-right">Valor</th>
            </tr>
          </thead>
          <tbody>
            {resumoAtribuicoes.map((item) => (
              <tr key={`confirma-${item.codigo}`}>
                <td>
                  {(cobradoresMap && cobradoresMap.get(item.codigo)) ||
                    `Cobrador ${item.codigo}`}
                </td>
                <td className="text-right">{item.quantidade}</td>
                <td className="text-right">{formatarBRL(item.valor)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Alert variant="warning" className="py-2 mb-0">
          A transferência grava em produção e dispara integrações externas
          (SCPC, Monitora). Confira os dados antes de confirmar.
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-secondary"
          onClick={onCancelar}
          disabled={emAndamento}
        >
          Cancelar
        </Button>
        <Button variant="success" onClick={onConfirmar} disabled={emAndamento}>
          {emAndamento ? 'Lançando...' : 'Confirmar lançamento'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalConfirmacaoLancamento;
